import { render } from "./BorrowerApplicationsTable.vue?vue&type=template&id=23d27376"
import script from "./BorrowerApplicationsTable.vue?vue&type=script&lang=js"
export * from "./BorrowerApplicationsTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__